import gql from 'graphql-tag'

export const SINCRONIZAR_DEALERS = gql`
  mutation SincronizarDealersMutation {
    sincronizarDealers
  }
`
